<app-header></app-header>

<ion-content scrollbar>
  <app-breadcrumb></app-breadcrumb>
  <ng-container *ngIf="!isError; else HTTPError">
    <div class="conteiner" *ngIf="loaded">
      <app-item-community
        refreshCommentsOnInit="true"
        singleArticle="true"
        [community]="community"
        [currentSegment]="currentSegment"
      ></app-item-community>
    </div>
    <div class="spin" *ngIf="!loaded">
      <app-loading-sti></app-loading-sti>
    </div>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="COMMUNITY.POST"
      link="app/community"
      returnText="COMMUNITY.RETURN_TO_COMMUNITY"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
